import React from 'react';
import { styled } from 'styled-components';
import { Colors } from '../../../../play-core/styles/Colors';
import { Fonts } from '../../../../play-core/styles/Fonts';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DateFilterColumn = ({
  heading,
  children
}) => /*#__PURE__*/_jsxs(StyledDateFilterColumn, {
  children: [/*#__PURE__*/_jsx(Heading, {
    children: heading
  }), /*#__PURE__*/_jsx(Content, {
    children: children
  })]
});
const StyledDateFilterColumn = styled.section.withConfig({
  displayName: "DateFilterColumn__StyledDateFilterColumn",
  componentId: "sc-sfle40-0"
})(["display:flex;flex-direction:column;"]);
const Heading = styled.h3.withConfig({
  displayName: "DateFilterColumn__Heading",
  componentId: "sc-sfle40-1"
})(["border-bottom:1px solid ", ";color:", ";", ";height:56px;display:flex;align-items:center;margin:0;"], Colors.GREY_2c2c2c, Colors.GREY_969696, Fonts.regular(16));
const Content = styled.div.withConfig({
  displayName: "DateFilterColumn__Content",
  componentId: "sc-sfle40-2"
})(["padding-right:26px;display:flex;flex:1 1 auto;min-height:210px;"]);